







import { getCouponStateText } from './business';
import { CouponState } from '../../type';
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class CouponItemStamp extends Vue {
  @Prop() public state!: CouponState;

  /**
   * 获取邮戳展示状态
   * 只有过期和已使用才展示
   */
  get isShowStamp() {
    return (
      this.state === CouponState.Expired || this.state === CouponState.Used
    );
  }

  /**
   * 获取邮戳文案
   */
  get stampText() {
    return getCouponStateText(this.state);
  }
}
